<template>
    <div style="height: 100%">
        <RupturaList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import RupturaList from '@/components/promotor/relatorio-analitico/relatorio-ruptura/RelatorioRupturaList.vue';

export default {
    name: 'RelatorioRupturaListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'relatorio-ruptura-list';
        if (from.name != 'relatorio-ruptura-list' && to.name == 'relatorio-ruptura-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        RupturaList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('relatorio-ruptura') &&
            this.$route.name != 'relatorio-ruptura-list';
    },
};
</script>
